import { render, staticRenderFns } from "./CommentsView.vue?vue&type=template&id=507189e5&scoped=true"
import script from "./CommentsView.vue?vue&type=script&lang=js"
export * from "./CommentsView.vue?vue&type=script&lang=js"
import style0 from "./CommentsView.vue?vue&type=style&index=0&id=507189e5&prod&lang=css"
import style1 from "./CommentsView.vue?vue&type=style&index=1&id=507189e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507189e5",
  null
  
)

export default component.exports